import React from "react";
import { commaSeperated } from "../../utils/functions";
import Tooltip from "../Tooltip/Tooltip";

const MoneyValue = ({
  modalLogo,
  title,
  amount,
  batchAmount,
  infoLogo,
  date1,
  hasWidth,
  hasBackground,
  totalAndIrr,
  totalAndUnit,
  tile,
  TooltipContent,
  tipClass,
  setToolTipModalOpen,
  totalReturnSubAsset,
  unitType,
}) => {
  const getClass = () => {
    if (title === "Total Gains" || (totalAndIrr && !totalReturnSubAsset)) {
      const amt = amount?.slice(0, -1);
      //if (Number(amount?.split(" ")[0] || "0") < 0)
      if (amt < 0) {
        return "money_amt negative";
      } else {
        return "money_amt money_color_green";
      }
    } else if (
      (title === "IRR" && tile === "infinity") ||
      (totalReturnSubAsset !== undefined && totalReturnSubAsset)
    ) {
      if (amount?.includes("-")) {
        return "money_amt negative";
      } else {
        return "money_amt money_color_green";
      }
    } else {
      if (hasBackground !== undefined) {
        return "money_amt clr_white";
      } else {
        return "money_amt money_color_black";
      }
    }
  };
  return (
    <div
      className={
        title === "Current Value2"
          ? "money_value_outside "
          : "money_value_outside"
      }
    >
      <div
        className={
          hasWidth ? "money_title_logo add_margin_btm" : "money_title_logo"
        }
      >
        <p
          className={
            hasBackground !== undefined
              ? "money_value_title clr_white"
              : "money_value_title clr_normal blueTextColor"
          }
        >
          {title}
        </p>
        {modalLogo !== undefined && (
          <button
            type="button"
            onClick={() => setToolTipModalOpen(true)}
            className="monye_info clickable information-modal-button"
            style={{ cursor: "pointer" }}
            aria-label={`${title} Info`}
          >
            <img src={modalLogo} alt="" />
          </button>
        )}
        {
          infoLogo !== undefined && (
            <Tooltip
              infoLogo={infoLogo}
              ariaLabel={"Total Returns (Irr) Information"}
              tooltipClass={tipClass}
            >
              {TooltipContent}
            </Tooltip>
          )
          // (
          //   <div className="img_wrapper">
          //     <img className="money_info info-image" src={infoLogo} alt="info" />
          //     <div className={`tool ${tipClass}`}>{TooltipContent}</div>
          //   </div>
          // )
        }{" "}
      </div>
      <div className="money">
        {!!totalAndIrr && (
          <p
            style={{ marginRight: "10px" }}
            className="money_amt  money_color_black"
          >
            {" "}
            {totalAndIrr?.split(" ")?.[0] &&
              commaSeperated(totalAndIrr?.split(" ")?.[0])}
            &nbsp;
            <span className="unitFont" style={{ textTransform: "capitalize" }}>
              {totalAndUnit && totalAndUnit.toLowerCase() !== "lacs"
                ? totalAndUnit
                : totalAndUnit
                  ? "L"
                  : ""}
            </span>
          </p>
        )}

        <p className={getClass()}>
          {totalAndIrr && amount === "-"
            ? ""
            : !amount?.includes("%")
              ? amount?.split(" ")?.[0] &&
                commaSeperated(amount?.split(" ")?.[0])
              : amount}{" "}
          <span className="unitFont">
            {unitType && unitType.toLowerCase() !== "lacs"
              ? unitType
              : unitType
                ? "L"
                : ""}
          </span>
        </p>
        {batchAmount &&
          (Number(batchAmount) < 0 ? (
            <span className="money_batch_red">
              {commaSeperated(batchAmount)}%
            </span>
          ) : batchAmount !== "-" ||
            batchAmount !== "" ||
            batchAmount !== null ? (
            <span className="money_batch_green">
              {commaSeperated(batchAmount)}%
            </span>
          ) : (
            <span>-</span>
          ))}
        {date1 !== undefined && (
          <span
            className={
              hasBackground !== undefined
                ? "money_date clr_white"
                : "money_date mny_date_clr_nrml blueTextColor"
            }
          >
            {date1}
          </span>
        )}
      </div>
    </div>
  );
};

export default MoneyValue;
